export const environment = {
  production: true,
  VIM_COOKIES_HASH: "dffb47",
  firebaseConfig: {
    apiKey: "AIzaSyCOi27EYgwSlirxy2tpKbhZgcW74FdvhDQ",
    authDomain: "hormiguitas-cebd5.firebaseapp.com",
    databaseURL: "https://hormiguitas-cebd5.firebaseio.com",
    projectId: "hormiguitas-cebd5",
    storageBucket: "",
    messagingSenderId: "524206109466",
    appId: "1:524206109466:web:1157d6df9bd448ac"
  },
  apiUrl: 'api',
  baseUrl: 'https://ants-dwc3eafdgjcybsgg.eastus-01.azurewebsites.net',
  sentryDsn: 'https://7cc07632de0c9356791be6f000c274f0@o4508682241769472.ingest.us.sentry.io/4508689917739008',
};
